import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme, { layout } from '../../theme.style';

export default mergeStyleSets({
  buttonContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center',
  },
  cancelButton: {
    marginRight: pxToRem(16),
    fontWeight: 400,
  },
  moduleHeaderText: {
    ...theme.fonts.large,
    selectors: {
      [layout.breakpoints.min.md]: {
        ...theme.fonts.xLarge,
      },
    },
  },
  modalText: {
    fontWeight: 400,
  },
  saving: {
    paddingTop: 0,
    marginLeft: pxToRem(10),
  },
});
